import { ActionType } from "./types";
import * as actionTypes from "../action";

const initialState: any = {
  isUserLoggedIn: false,
  user: null,
  sessionTimeoutError: false,
};

const userReducers = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        isUserLoggedIn: true,
        user: action.payload,
      };
    }
    case actionTypes.LOG_OUT: {
      return {
        ...state,
        isUserLoggedIn: false,
        user: null,
      };
    }
    case actionTypes.SET_SESSION_TIMEOUT_ERROR: {
      return {
        ...state,
        sessionTimeoutError: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default userReducers;
